import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Protected route for staff/admin only
 * Blocks drivers from accessing staff pages (they should be redirected on login)
 */
const StaffRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-floral-600 mx-auto"></div>
          <p className="text-floral-600 mt-4">Loading...</p>
        </div>
      </div>
    );
  }

  // Block drivers - show access denied message
  if (user && user.accountType === 'driver') {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center bg-white rounded-lg shadow-lg p-8 max-w-md">
          <div className="text-6xl mb-4">🚫</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Access Denied</h2>
          <p className="text-gray-600 mb-4">This page is only available to staff members.</p>
          <a
            href="/driver"
            className="inline-block px-6 py-2 bg-floral-600 text-white rounded-lg hover:bg-floral-700 transition-colors"
          >
            Go to Driver Dashboard
          </a>
        </div>
      </div>
    );
  }

  // User is authenticated and is staff/admin
  return children;
};

export default StaffRoute;
